import { useQuery } from "@tanstack/react-query";
import { getPublicAuthHeader, getReturnWidgetFetchClient } from "./return-widget-client";
import type { ProductSearchItemDto } from "../generated/schema";

export async function publicSearchProducts(
  shopId: string,
  q: string,
): Promise<ProductSearchItemDto[]> {
  const { data, error } = await getReturnWidgetFetchClient().GET("/public/products/search", {
    params: { query: { shopId, q }, header: getPublicAuthHeader() },
  });
  if (error) throw error;
  return data;
}

export function usePublicProductSearch(shopId: string, q: string) {
  return useQuery({
    queryKey: ["public-product-search", shopId, q],
    queryFn: () => publicSearchProducts(shopId, q),
    enabled: !!shopId,
    staleTime: 60 * 1000,
  });
}
